import { useQuery } from "@tanstack/react-query";
import * as answeringSubjectsApi from "@/lib/api/flow-instances/answering-subjects";

export const answeringSubjectsKeys = {
  value: (id: string | null) => ["flowInstances", id, "answering-subjects"] as const,
};

/**
 * QL-505 — who answers the product-assessment and quiz components for this
 * instance's client right now: the attribution banner (or per-member list).
 * Read-only, no invalidation call sites of its own — see the contract note on
 * membership changes.
 */
export function useAnsweringSubjects(instanceId: string | null) {
  const { data, error, isLoading } = useQuery({
    queryKey: answeringSubjectsKeys.value(instanceId),
    queryFn: () => answeringSubjectsApi.getAnsweringSubjects(instanceId!),
    enabled: !!instanceId,
  });
  return { attribution: data?.attribution ?? null, error, isLoading };
}
